import { useState, useEffect } from 'react';

/**
 * useDebounce - Debounce a value change
 * @param {any} value - The value to debounce
 * @param {number} delay - Delay in ms (default: 500)
 */
export function useDebounce(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
